import React from 'react';
import Pageheader from '../utils/headerHelment';
import VDR from '../components/VDR';

const DataroomView = () => {
    return (
        <>
            <Pageheader title="LENS - VDR" />
            <VDR />
        </>
    );
};

export default DataroomView;
